<script setup>
import MovieOpenIcon from 'vue-material-design-icons/MovieOpen.vue';
</script>

<template>
    <div v-if="data" class="col-4 d-none d-lg-inline" style="padding: 15px;">
        <div class="card fp-card" style="height: 300px;">
          <div class="row g-0 h-100">
            <div class="col-md-4 h-100" style="height: auto;">
              <img :src="data.image" style="object-fit: cover;" class="img-fluid rounded-start h-100 w-100" alt="...">
            </div>
            <div class="col-12 col-md-8">
              <img class="d-lg-none card-img-top" :src="data.image" height="128" style="object-fit: cover;" alt="...">
              <div class="card-body">
                <h5 class="card-title">{{ data.title }}</h5>
                <div class="badges" style="position: absolute; top: 10px; left: 10px;">
                  <span v-if='badges.movie.show && data.badges.movie' class="badge rounded-pill bg-primary text-white"><table><tr><td><MovieOpenIcon class="me-1" :size="20"/></td><td>{{ badges.movie.label }}</td></tr></table></span>
                </div>
                <p class="card-text">{{ data.preview }}...</p>
                <p class="card-text"><small>Pubblicato il {{ new Date(data.date).getDate() }} {{ months[new Date(data.date).getMonth()] }} {{ new Date(data.date).getFullYear() }}</small></p>
                <RouterLink :to='"/news/" + data.id' class="btn btn-primary text-white">Leggi articolo</RouterLink>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="data" class="col-12 d-lg-none" style="padding: 15px;">
        <div class="card fp-card">
          <div class="row g-0 h-100">
            <div class="col-12">
              <img class="d-lg-none card-img-top" :src="data.image" height="128" style="object-fit: cover;" alt="...">
              <div class="card-body">
                <h5 class="card-title">{{ data.title }}</h5>
                <div class="badges" style="position: absolute; top: 10px; left: 10px;">
                  <span v-if='badges.movie.show && data.badges.movie' class="badge rounded-pill bg-primary text-white"><table><tr><td><MovieOpenIcon class="me-1" :size="20"/></td><td>{{ badges.movie.label }}</td></tr></table></span>
                </div>
                <p class="card-text">{{ data.preview }}</p>
                <p class="card-text"><small>Pubblicato il {{ new Date(data.date).getDate() }} {{ months[new Date(data.date).getMonth()] }} {{ new Date(data.date).getFullYear() }}</small></p>
                <RouterLink :to='"/news/" + data.id' class="btn btn-primary text-white">Leggi articolo</RouterLink>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['data'],
    data() {
        return {
            badges: {
              movie: {
                show: true,
                label: "Film"
              }
            },
            months: ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"]
        }
    },
    methods: {
        unescapeHtml: function(html) {
            var txt = document.createElement("textarea");
            txt.innerHTML = html.replace("<script>", "");
            return txt.value;
        }
    }
}
</script>